import styled from 'styled-components'
import { Typography } from 'common/typography'
import Wrapper from 'common/wrapper'
import { SecondaryButton } from 'common/button'
import { usePortfolio } from 'querys/portfolio'
import { MdEmail } from 'react-icons/md'
import SocialMedia from './social-media'

const PortfolioContactStyled = styled.section`
  text-align: center;
  padding-block-start: 64px;
  padding-block-end: 24px;
  background-image:
    radial-gradient(104% 104% at 50% 50%, #112D55 0%, #04001E 41.64%),
    radial-gradient(104% 104% at 50% 50%, #172875 0%, #04001E 43.59%);
  background-size: 200px 200px, 530px 530px;
  background-position: left top, 45vw 25vh;
  background-repeat: no-repeat;
  scroll-margin-top: 50px;
  h2 {
    padding: 0 24px;
  }
  .work-together {
    margin: 16px auto 40px;
    max-inline-size: 630px;
  }
  .contact-me {
    font-weight: 700;
    margin-block-end: 16px;
  }
  .social-media {
    margin-block-start: 40px;
  }
  .powered-by {
    font: var(--p2Regular);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin: 80px auto 0;
  }
  @media (min-width: 768px) {
    background-size: 350px 350px, 700px 700px;
    background-position: left top, 50vw 25vh;
    h2 {
      padding: 0;
    }
    .powered-by {
      margin-block-start: 140px;
    }
  }
  @media (min-width: 1024px) {
    padding-block-start: 200px;
    background-size: 500px 500px, 1200px 1200px;
    background-position: left top, 45vw 10vh;
    .powered-by {
      margin-block-start: 200px;
    }
    .social-media {
      margin-block-start: 80px;
    }
    .work-together {
      margin: 16px auto 48px;
    }
  }
  @media (min-width: 1920px) {
    background-size: 500px 500px, 1600px 1600px;
    background-position: 10vw top, 40vw 8vh;
  }
`

function PortfolioContact() {
  const {
    data: {
      email, contact_title, contact_description, contact_email,
    },
  } = usePortfolio()

  return (
    <PortfolioContactStyled id="contacto" aria-labelledby="work-together">
      <Wrapper maxWidth={790}>
        <Typography as="h2" small="headline4" large="headline2" id="work-together">
          {contact_title || 'Vamos a trabajar juntos'}
        </Typography>
        <Typography className="work-together" as="p" font="regular">
          {contact_description || 'Si tienes en mente una idea para una aplicación móvil o un sitio web, no dudes en contactarme para hacerla realidad juntos.'}
        </Typography>
        <Typography font="regular" className="contact-me">
          ¿Tienes un proyecto increíble? Envíame un correo.
        </Typography>
        <SecondaryButton as="a" href={`mailto:${email}`}>
          <MdEmail color="white" size={16} />
          {contact_email || email}
        </SecondaryButton>
        <div className="social-media">
          <SocialMedia />
        </div>
      </Wrapper>
      <a className="powered-by" href="https://leonidasesteban.com/" target="_blank">
        <img
          width="30"
          height="30"
          src="/icons/icon-96x96.png"
          alt="El logotipo de la plataforma, un cohete formado por dos triangulos de materiales coloridos y brillantes"
        />
        <p>Powered by LeonidasEsteban.com</p>
      </a>
    </PortfolioContactStyled>
  )
}

export default PortfolioContact
